import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const OfferImageDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[offer/image] Delete'),
  requestFail: uniqueActionType('[offer/image] Delete fail'),
  requestSuccess: uniqueActionType('[offer/image] Delete success'),
  requestClearErrors: uniqueActionType('[offer/image] Delete clear errors'),
  requestClear: uniqueActionType('[offer/image] Delete clear')
};

export class OfferImageDeleteAction implements PayloadAction {
  readonly type = OfferImageDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class OfferImageDeleteFailAction implements PayloadAction {
  readonly type = OfferImageDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class OfferImageDeleteSuccessAction implements PayloadAction {
  readonly type = OfferImageDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class OfferImageDeleteClearErrorsAction implements PayloadAction {
  readonly type = OfferImageDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class OfferImageDeleteClearAction implements PayloadAction {
  readonly type = OfferImageDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
